export const erpStatusNoteSection = "/statusnote";
